import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearNoteAction, getNoteByIdAction } from '../../redux/actions/notesActions';

const useFetchNote = (noteId) => {
  const dispatch = useDispatch();
  const note = useSelector((state) => state.notes?.note);
  const loading = useSelector((state) => state.notes?.noteLoading);

  const fetchNote = useCallback(async () => {
    await dispatch(getNoteByIdAction(noteId));
  }, [dispatch, noteId]);

  useEffect(() => {
    fetchNote();
  }, [fetchNote]);

  useEffect(() => {
    return () => {
      dispatch(clearNoteAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchNote();
  };

  return { loading, note, refresh };
};

export default useFetchNote;
